"use strict";
'use es6';

var _loggers = require("customer-data-tracking/loggers");

var eventName = 'use-android-app-installprompt';
window.addEventListener('beforeinstallprompt', function (evt) {
  _loggers.CrmLogger.log(eventName, {
    what_event_subtype: 'seen'
  });

  evt.userChoice.then(function (choiceResult) {
    var platform = choiceResult.platform,
        outcome = choiceResult.outcome;

    _loggers.CrmLogger.log(eventName, {
      what_event_subtype: outcome + " " + platform
    });
  });
});